import { render } from "./upload-file.vue?vue&type=template&id=11461c1c&ts=true"
import script from "./upload-file.ts?vue&type=script&lang=ts&external"
export * from "./upload-file.ts?vue&type=script&lang=ts&external"

import "./upload-file.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__